import { render, staticRenderFns } from "./VehicleDashboard.vue?vue&type=template&id=3a2597c3&"
import script from "./VehicleDashboard.vue?vue&type=script&lang=js&"
export * from "./VehicleDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports